<template>
    <el-container>
        <div :style="'width: 100%; background: '+adv.color+'; text-align: center;'" v-if="adv.id>0">
          <a @click="advClick" >
            <img :src="adv.img" style="max-height: 100px; display: block; margin: 0 auto;">
          </a>
        </div>
        <el-header height="64px">
            <div class="header">
                <div class="logo"><span>商家中心</span></div>
                <div class="navs">
                    <div v-for="item in navList" :key="'nav' + item.id" :class="'nav' + (active.nav == item.id ? ' nav_hover' : '')" @click="handleNav(item)">{{ item.name }}</div>
                </div>
                <div class="user">
                    <a class="big_view" :href="userInfo.domain" target="_blank"><i class="el-icon-s-home"></i></a>
                    <el-link class="big_view">
                      <i class="el-icon-message" @click="gotoMessage" style="color: #ffffff;"></i>
                      <el-badge :value="unreadNum" class="item" :max="99" v-if="unreadNum>0">
                        <a href="#" class="head-example" />
                      </el-badge>
                    </el-link>
                    <img :src="userInfo.avatar" />
                    <el-dropdown @command="handleCommand">
                        <div class="username">{{ userInfo.name }}</div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-lock" command="gotoPassword">修改密码</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-switch-button" command="logout">退出登录</el-dropdown-item>
                            <!--小于640px显示-->
                            <a :href="userInfo.domain" target="_blank" class="small_view">
                                <el-dropdown-item icon="el-icon-s-home" >商家网站</el-dropdown-item>
                            </a>
                            <a @click="gotoMessage" class="small_view">
                                <el-dropdown-item icon="el-icon-message" >站内消息</el-dropdown-item>
                            </a>
                            
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </el-header>
        <el-container>
            <el-aside width="185px" v-if="pageName!='AI文案助手'"  class="small_aside">
                <div class="side">
                    <div class="menus">
                        <div v-for="item in menuList" :key="'menu' + item.id" v-if="item.is_menu == 1" :class="'menu' + (active.menu == item.id ? ' menu_hover' : '')" @click="handleMenu(item)">
                            <i :class="item.icon"></i>
                            <span>{{ item.name }}</span>
                        </div>
                    </div>
                </div>
            </el-aside>
            <el-main>
                <div class="title" v-if="isMenu==1 && pageName!='AI文案助手'">{{ pageName }}</div>
                <div  v-else-if="isMenu==0">
                  <el-page-header @back="goBack" :content="pageName">
                  </el-page-header>
                </div>
                <div class="content">
                    <router-view></router-view>
                </div>
            </el-main>
        </el-container>
        
        <a href="javascript:;" class="small_menu_tag" @click="controlMenu">
            <i class="el-icon-menu"></i>
        </a>
        <el-dialog  
            :visible.sync="small_menu_show" 
            width="30%" 
            custom-class="small_menu_show_01"
            >  
            <!-- <p> -->
                <el-row class="tac">
                    <el-col>                      
                        <el-menu
                        default-active="2"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose"
                        background-color="#FFFFFF"
                        text-color="#333" 
                        active-text-color="#2676FF">
                            <div v-for="item in navList" :key="'nav' + item.id">
                                <el-submenu :index="'nav' + item.id">
                                    <template slot="title">
                                    <!-- <i class="el-icon-location"></i> -->
                                    <span>{{item.name}}</span>
                                    </template>
                                    <el-menu-item-group >
                                        <div v-for="item1 in item.child" :key="'nav' + item1.id">
                                
                                                <el-menu-item :index="'nav' + item1.id"  @click="handlePhoneMenu(item1)">{{item1.name}}</el-menu-item>
                                        </div>
                                    </el-menu-item-group>
                                   
                                </el-submenu>
                            </div>                                               
                        </el-menu>
                    </el-col>
                </el-row>
            <!-- </p>   -->
        </el-dialog>  

    </el-container>
</template>

<script>
import Cookies from "js-cookie";

export default {
    data() {
        return {
            navList: [],
            active: {
                nav: '',
                menu: ''
            },
            userInfo: {
                name: '',
                avatar: '',
                domain: ''
            },
            menuList: [],
            pageName: '',
            unreadNum:0,
            isMenu:1,
            adv:{},
            currentNav:0,
            small_menu_show: false,
            screenSizeThreshold: 640 
        };
    },
    watch: {
        $route(to, from) {
            this.getCurrent();
        },
    },
    async created() {
        var navs = await this.$util.routes();
        this.navList = this.navList.concat(navs);
        this.getCurrent();
        this.getAdminInfo();
        this.getUnread()
        this.$EventBus.$on("sclook", () => {
          setTimeout(() => {
            this.getUnread()
          }, 500)
        })
        this.getAdv()
    },
    methods: {
        getAdv(){
          this.$util.api("/common/adv", {}, (res) => {
            if (res.code == 10000) {
              this.adv=res.data
            }
          });
        },
        advClick(){
          var _this = this;

          if(_this.adv.id>0){
            _this.$util.api('/adv/click',{adv_id:_this.adv.id,url:_this.adv.url},function(res){

            });
          }
          window.open(_this.adv.url,'_blank');
        },
        handleMenu(item){
          this.currentNav=item.parent
          if(item.redirect == '' || item.redirect==undefined){
              this.$router.push(item.route);
          }else{
              window.location.href = this.$util.getHost() + (item.redirect == 'index' ? '' : item.redirect)
          }
        },
        handlePhoneMenu(item){
          this.small_menu_show = !this.small_menu_show  
          this.currentNav=item.parent
          if(item.redirect == '' || item.redirect==undefined){
              this.$router.push(item.route);
          }else{
              window.location.href = this.$util.getHost() + (item.redirect == 'index' ? '' : item.redirect)
          }
        },
        handleNav(item){
            this.currentNav=item.id
            this.active = {nav: this.currentNav,menu:item.child[0].id}
            this.menuList = item.child;
            this.handleMenu(item.child[0]);
        },
        handleCommand(commond){
            if(commond == 'gotoPassword'){
                this.$router.push('/password');
            }else if(commond == 'logout'){

              this.$util.api('/login/logout',{}, res => {

                if(res.code == 10000){
                  this.$message.success("退出成功");
                  localStorage.removeItem('UserInfo');
                  localStorage.removeItem('Router');
                  Cookies.remove('ShopAdminToken', { path: '/' ,domain:'91jf.com'})
                  this.$router.push('/login');
                }else{
                  this.$message.error(res.msg);
                }

              });


            }
        },
        gotoMessage(){
            this.$router.push('/message');
        },
        getUnread() {
          this.$util.api("/admin/noread", {}, (res) => {
            if (res.code == 10000) {
              this.unreadNum = res.data
            }
          });
        },
        getCurrent(){
            var path = this.$route.path;
            var menu = [];
            var name = '';
            var active = {
                nav: '',
                menu: ''
            };
            var is_menu=1;

            var url = '';
            var relation = {
                '/message/:id': '/message'
            }

            if(this.$route.params){
                for (let key in this.$route.params){
                    path = path.replace(this.$route.params[key],':' + key)
                }
            }

            url = path;
            
            if(typeof relation[path] != 'undefined'){
                path = relation[path];
            }


            if(url==='/home'){
              this.currentNav=0;
            }

            if(this.currentNav===0 || this.currentNav===''){
              var start=0;
            }else{
              var start=1
            }
            for(var i = start; i < this.navList.length; i++){
                var flag = false;
                var child = this.navList[i].child;

                if(child){
                    for(var j = 0; j < child.length; j++){
                        if(child[j].route == url){
                            name = child[j].name;
                            is_menu = child[j].is_menu;
                            break;
                        }
                    }

                    for(var j = 0; j < child.length; j++){
                        if(child[j].route == path){
                            flag = true;
                            active.menu = child[j].id;

                            break;
                        }
                    }
                }
                
                if(flag){
                    menu = child;
                    active.nav = this.navList[i].id;
                    break;
                }
            }
            // console.log(active)
            this.menuList = menu;
            this.active = active;
            this.pageName = name;
            this.isMenu = is_menu;
        },
        getAdminInfo: async function(){
          this.userInfo = await this.$util.userinfo();
        },
        goBack() {
          this.$router.go(-1)
        },
        controlMenu(){
            this.small_menu_show = !this.small_menu_show
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        }
    },
};
</script>
<style scoped>
@media only screen and (min-width: 640px) {
    .user{
        width: 250px;
        text-align: right;
        padding-right: 20px;
    }
    .user i{
        cursor: pointer;
        margin-right: 20px;
    }
    .user a{
        color: #ffffff;
    }
    .user i:hover, .user a:hover{
        opacity: 0.8;
    }
    .user img{
        width: 26px;
        height: 26px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 5px;
    }
    .username{
        display: inline-block;
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        color: #fff;
    cursor: pointer;
    }
    .menu{
        height: 44px;
        line-height: 44px;
        color: #333;
        font-size: 14px;
        cursor: pointer;
        padding-left: 20px;
    }
    .menu span{
        margin-left: 10px;
    }
    .menu:hover, .menu_hover{
        background: #EBF7FF;
        color: #2676FF;
        border-right: 2px solid #2676FF;
    }
    .menus{
        padding-top: 10px;
    }
    .nav{
        font-size: 16px;
        display: inline-block;
        margin: 0 25px;
        cursor: pointer;
        opacity: 0.8;
        height: 40px;
        line-height: 40px;
    }
    .nav:hover, .nav_hover{
        opacity: 1;
        border-bottom: 2px solid #ffffff;
    }
    .navs{
        flex: 1;
        width:100%;
        white-space:nowrap;
        display: inline-block;
    }
    .logo{
        width: 120px;
        background: url('@/assets/images/logo.png') no-repeat left center;
        background-size: 62px 20px;
        padding-left: 80px;
        background-position: 10px center;
    }
    .logo span{
        border-left: 1px solid #ffffff;
        padding-left: 8px;
    }
    .header{
        height: 64px;
        background: linear-gradient(270deg, #4EAEFF 0%, #2676FF 100%);
        display: flex;
        color: #ffffff;
        font-size: 16px;
        line-height: 64px;
    }
    .el-header{
        padding: 0;
    }
    .side{
        width: 180px;
        height: calc(100vh - 64px);
        background: #FFFFFF;
        box-shadow: 2px 0px 6px 0px rgba(0,21,41,0.12);
    }
    .title{
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        font-weight: 500;
        color: #000000;
    }
    .el-page-header{
    margin-top: 10px;
    margin-bottom: 10px;
    }
    .el-main{
        padding: 0 20px 0;
    }
    .content{
        height: calc(100vh - 114px);
        overflow: auto;
    }
    /deep/ .el-badge__content.is-fixed {
        position: absolute;
        top: -10px;
        right: 25px;
        transform: translateY(-50%) translateX(100%);
    }
    /deep/ .el-badge__content {
        border-radius: 50%;
        font-size: 10px;
        height: 16px;
        line-height: 16px;
        padding: 0 3px;
        border:none;
    }

    .small_view{
        display: none;
    }
    
    .small_menu_tag{
        display: none;
    }
    /* .big_view{
        display: block;
    } */

    .small_aside{
        display: block;
    }
}   

@media only screen and (max-width: 640px) {
    .user{
        width: 250px;
        text-align: right;
        padding-right: 20px;
    }
    .user i{
        cursor: pointer;
        margin-right: 20px;
    }
    .user a{
        color: #ffffff;
    }
    .user i:hover, .user a:hover{
        opacity: 0.8;
    }
    .user img{
        width: 26px;
        height: 26px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 5px;
    }
    .username{
        display: inline-block;
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        color: #fff;
    cursor: pointer;
    }
    .menu{
        height: 44px;
        line-height: 44px;
        color: #333;
        font-size: 14px;
        cursor: pointer;
        padding-left: 20px;
    }
    .menu span{
        margin-left: 10px;
    }
    .menu:hover, .menu_hover{
        background: #EBF7FF;
        color: #2676FF;
        border-right: 2px solid #2676FF;
    }
    .menus{
        padding-top: 10px;
    }
    .nav{
        font-size: 16px;
        display: inline-block;
        margin: 0 25px;
        cursor: pointer;
        opacity: 0.8;
        height: 40px;
        line-height: 40px;
    }
    .nav:hover, .nav_hover{
        opacity: 1;
        border-bottom: 2px solid #ffffff;
    }
    .navs{
        flex: 1;
        width:100%;
        white-space:nowrap;
        display: none;
    }
    .logo{
        width: 120px;
        background: url('@/assets/images/logo.png') no-repeat left center;
        background-size: 62px 20px;
        padding-left: 80px;
        background-position: 10px center;
    }
    .logo span{
        border-left: 1px solid #ffffff;
        padding-left: 8px;
    }
    .header{
        height: 64px;
        background: linear-gradient(270deg, #4EAEFF 0%, #2676FF 100%);
        display: flex;
        color: #ffffff;
        font-size: 16px;
        line-height: 64px;
    }
    .el-header{
        padding: 0;
    }
    .side{
        width: 180px;
        height: calc(100vh - 64px);
        background: #FFFFFF;
        box-shadow: 2px 0px 6px 0px rgba(0,21,41,0.12);
    }
    .title{
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        font-weight: 500;
        color: #000000;
        text-align: center;
    }
    .el-page-header{
    margin-top: 10px;
    margin-bottom: 10px;
    }
    .el-main{
        padding: 0 20px 0;
    }
    .content{
        min-height: 100hv;
        /* overflow: auto; */
    }
    /deep/ .el-badge__content.is-fixed {
        position: absolute;
        top: -10px;
        right: 25px;
        transform: translateY(-50%) translateX(100%);
    }
    /deep/ .el-badge__content {
        border-radius: 50%;
        font-size: 10px;
        height: 16px;
        line-height: 16px;
        padding: 0 3px;
        border:none;
    }
    .small_view{
        display: block;
    }

    .big_view{
        display: none;
    }

    .small_menu_tag{
        position: fixed;
        bottom: 6rem;
        right: 4rem;
        box-shadow: 0 0 0.5rem 0.2rem #e8e8e8;
        opacity: 0.8;
        background: #fff;
        z-index: 101;
        width: 4.8rem;
        height: 4.8rem;
        font-size: 2.4rem;
        line-height: 4.8rem;
        border-radius: 50%;
        text-align: center;
        font-size: 32px;
    }

    .small_menu_tag:hover{
        background: #5cb6ff;
    }

    /deep/ .el-icon-menu:before {
    content: "\e798";
        color: #409EFF;
    }

    /deep/ .small_menu_show_01 {
        width: 40% !important;
        min-height: 100vh !important;
        margin:0 !important;
        background: #FFFFFF !important;
        overflow: hidden;
    }

    /deep/ .small_menu_show_01 .el-dialog__header {
        display: none;
    }
    
    /deep/ .small_menu_show_01 .el-submenu .el-menu-item {
        min-width: 10% !important;
    }
    /deep/ .small_menu_show_01 .el-dialog__body {
        padding: 0;
        margin-top: 64px;
    }

    .small_aside{
        display: none;
    }
} 
</style>